import { DocumentFormSettingsKey, VideoFormSettingsKey,ContactFormSettingsKey, CustomResourceFormSettingsKey  } from "../../form-settings/form-experience/form-settings-keys.js";

type FormKeyValues = DocumentFormSettingsKey | VideoFormSettingsKey | ContactFormSettingsKey | CustomResourceFormSettingsKey ;
export type SubmitButtonTranslationKey<TName extends string> =`${TName}-Submit-Button`;
const FormSettingTypes = [...DocumentFormSettingsKey, ...VideoFormSettingsKey, ...ContactFormSettingsKey] as const;

type FormMapType = SubmitButtonTranslationKey<FormKeyValues>;
const FormSettingTypeMap = FormSettingTypes.map(x => `${x}-Submit-Button`) as FormMapType[];

export const SubmitButtonTextKeys = [
  ...FormSettingTypeMap,
] as const;

export type SubmitButtonKeys = typeof SubmitButtonTextKeys[number];

export type SubmitButtonTranslationObj = {
  readonly [Key in SubmitButtonKeys]: string;
};